export default __webpack_public_path__ + "static/lateral1-12330ee1de481a0961330b556698f972.png";